import React, { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import {
  StrategyContextProvider,
  SetUpdateHookContextProvider,
  PathHook
} from '../hooks/datatabs';
import { Nullable, Strategy } from '../types/types';
import StrategyHeader from '../containers/strategies/pageheader';
import { strategiesTabs } from '../utils/tabs';
import DisplayTabs from '../components/layout/tabs/tabs';
import { StrategyService } from '../services/strategy';
import ServiceError from '../services/errors';
import ErrorPageManager from '../components/Error/errorpagemanager';
import TabsRouter from './tabsrouter';

function StrategyRouter(): ReactElement {
  const { id } = useParams<{ id: string }>();
  const [update, setUpdate] = useState(true);
  const [data, setData] = useState<Nullable<Strategy>>(null);
  const strategyService = new StrategyService();
  const [error, setError] = useState<Nullable<ServiceError>>(null);

  useEffect(() => {
    if (update && id) {
      data && setData(null);

      strategyService.getEntity(id)
        .then((apiResp) => {
          setData(apiResp.data);
          setUpdate(false);
        })
        .catch((err) => {
          setError(ServiceError.ensureServiceError(err));
          setUpdate(false);
        });
    }
  }, [update, id]);

  PathHook(`${data?.name}`);

  return (
    <SetUpdateHookContextProvider value={setUpdate}>
      <Grid container spacing={2}>
        {error ? <ErrorPageManager error={error} /> :
          <StrategyContextProvider value={data}>
            <Grid item xs={12}>
              <StrategyHeader entity={data} />
            </Grid>
            <Grid item xs={12}>
              <DisplayTabs tabs={strategiesTabs} />
            </Grid>
            <Grid item xs={12}>
              <TabsRouter tabs={strategiesTabs} />
            </Grid>
          </StrategyContextProvider>
        }
      </Grid>
    </SetUpdateHookContextProvider>
  );
}

export default StrategyRouter;
